import { useState } from 'react'
import { Table, Button, Dialog } from '@/ui'
import { DateTime } from 'luxon'

import { UserWithAdminInfo } from '@/reducers/admin/allUsersReducer'
import {
  adminDeleteUserActionItem,
  UserActionItem,
} from '@/features/user/dashboard/user-action-items/lib/userActionItems.slice'
import { DATE_FORMATS_LUXON } from '@/utils/dateHelpers'
import { useAppDispatch } from '@/utils/typeHelpers'

const UserActionItemRow = ({
  userActionItem,
  user,
}: {
  userActionItem: UserActionItem
  user: UserWithAdminInfo
}) => {
  const [confirmOpen, setConfirmOpen] = useState(false)
  const dispatch = useAppDispatch()
  const removeAction = async () => {
    const res = await adminDeleteUserActionItem(
      userActionItem.id,
      user.id
    )(dispatch)
    if (res) {
      setConfirmOpen(false)
    }
  }

  return (
    <Table.Row>
      <Table.Cell>{userActionItem.id}</Table.Cell>
      <Table.Cell>{userActionItem.actionItem?.description}</Table.Cell>
      <Table.Cell>
        {userActionItem.actionItem?.actionItemCategory?.title}
      </Table.Cell>
      <Table.Cell>{userActionItem.actionItem.actionLink}</Table.Cell>
      <Table.Cell>
        {userActionItem.createdAt &&
          DateTime.fromISO(userActionItem.createdAt).toFormat(
            DATE_FORMATS_LUXON.DISPLAY_SHORT
          )}
      </Table.Cell>
      <Table.Cell className={!userActionItem.completedAt ? 'text-red-500' : ''}>
        {userActionItem.completedAt &&
          DateTime.fromISO(userActionItem.completedAt).toFormat(
            DATE_FORMATS_LUXON.DISPLAY_SHORT
          )}
      </Table.Cell>
      <Table.Cell>
        <Dialog open={confirmOpen} onClose={() => setConfirmOpen(false)}>
          <Dialog.Trigger asChild>
            <Button variant="link" onClick={() => setConfirmOpen(true)}>
              Remove
            </Button>
          </Dialog.Trigger>
          <Dialog.Content>
            <Dialog.Title>Remove Todo</Dialog.Title>
            Are you sure you want to remove this action item from the
            User&apos;s Dashboard?
            <Dialog.Footer>
              <Button onClick={() => setConfirmOpen(false)} variant="primary">
                Cancel
              </Button>
              <Button onClick={() => removeAction()}>Remove Todo</Button>
            </Dialog.Footer>
          </Dialog.Content>
        </Dialog>
      </Table.Cell>
    </Table.Row>
  )
}
export const UserActionItemsTable = ({
  actionItems,
  user,
}: {
  actionItems: UserActionItem[]
  user: UserWithAdminInfo
}) => {
  return (
    <Table compact="very">
      <Table.Header>
        <Table.Row>
          <Table.HeaderCell>Id</Table.HeaderCell>
          <Table.HeaderCell>Todo Name</Table.HeaderCell>
          <Table.HeaderCell>Action Category</Table.HeaderCell>
          <Table.HeaderCell>Action Link</Table.HeaderCell>
          <Table.HeaderCell>Action Assigned On</Table.HeaderCell>
          <Table.HeaderCell>Completed On</Table.HeaderCell>
          <Table.HeaderCell>Delete</Table.HeaderCell>
        </Table.Row>
      </Table.Header>
      <Table.Body>
        {actionItems.map((item, key) => {
          return (
            <UserActionItemRow userActionItem={item} user={user} key={key} />
          )
        })}
      </Table.Body>
    </Table>
  )
}
